import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    roles: [],
    role: {},
    total: 0,
    pages: 0,
    current: 0,
    error: null,
    uloader: false,
    loading: false,
}

export const createRoleReq = createAsyncThunk('createRoleReq', async ({ data, navigate }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/role/create`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                    navigate('/admin/roles')
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const listRoleReq = createAsyncThunk('listRoleReq', async ({ text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/role/list?text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const singleRoleReq = createAsyncThunk('singleRoleReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/role/info/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const updateRolePermissionReq = createAsyncThunk('updateRolePermissionReq', async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/role/permission/update/${id}`, data,
            { headers: headers() })
            .then((res) => {
                dispatch(singleRoleReq({ id }))
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const assignUserRoleReq = createAsyncThunk('assignUserRoleReq', async ({ data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.post(`${BASEURL}/admin/user/assign/role`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const deleteRoleReq = createAsyncThunk('deleteRoleReq', async ({ id, text }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.delete(`${BASEURL}/admin/role/delete/${id}`,
            { headers: headers() })
            .then((res) => {
                dispatch(listRoleReq({ text: text }))
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})


export const RoleSlice = createSlice({
    name: 'roleSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(createRoleReq.pending, (state, action) => {
            state.loading = true
            return state
        })
        builder.addCase(createRoleReq.fulfilled, (state, action) => {
            state.loading = false
            return state
        })
        builder.addCase(createRoleReq.rejected, (state, action) => {
            state.loading = false
            state.error = 'Error occured'
        })
        builder.addCase(listRoleReq.pending, (state, action) => {
            state.loading = true
            state.roles = []
            return state
        })
        builder.addCase(listRoleReq.fulfilled, (state, action) => {
            state.loading = false
            state.roles = action.payload.data
            return state
        })
        builder.addCase(listRoleReq.rejected, (state, action) => {
            state.loading = false
            state.roles = []
            state.error = 'Error occured'
        })
        builder.addCase(singleRoleReq.pending, (state, action) => {
            state.loading = true
            state.role = {}
            return state
        })
        builder.addCase(singleRoleReq.fulfilled, (state, action) => {
            state.loading = false
            state.role = action.payload.data
            return state
        })
        builder.addCase(singleRoleReq.rejected, (state, action) => {
            state.loading = false
            state.role = {}
            state.error = 'Error occured'
        })
        builder.addCase(updateRolePermissionReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(updateRolePermissionReq.fulfilled, (state, action) => {
            state.uloader = false
            return state
        })
        builder.addCase(updateRolePermissionReq.rejected, (state, action) => {
            state.uloader = false
            state.error = 'Error occured'
        })
        builder.addCase(assignUserRoleReq.pending, (state, action) => {
            state.uloader = true
            return state
        })
        builder.addCase(assignUserRoleReq.fulfilled, (state, action) => {
            state.uloader = false
            return state
        })
        builder.addCase(assignUserRoleReq.rejected, (state, action) => {
            state.uloader = false
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default RoleSlice.reducer